import { Component , OnInit} from '@angular/core';
import { map } from 'rxjs/operators';
import { ChoosenPositions, Positions } from "../../../_shared/interfaces";
import { bundleIcon, ClarityIcons, nodeIcon, plusIcon, twoWayArrowsIcon} from "@cds/core/icon";
import { ActivatedRoute, RouterLink } from "@angular/router";
import { ProjectsStoreService } from "../../../_shared/services";
import { DatePipe, JsonPipe, NgIf } from "@angular/common";
import { ClrDatagridModule, ClrIconModule } from "@clr/angular";
import { RequestFormComponent } from "../request-form/request-form.component";

import { environment as env } from '../../../../environments/environment';

@Component({
  selector: 'app-request-add',
  standalone: true,
  imports: [
    RouterLink,
    NgIf,
    ClrIconModule,
    ClrDatagridModule,
    DatePipe,
    JsonPipe,
    RequestFormComponent
  ],
  templateUrl: './request-add.component.html',
  styleUrl: './request-add.component.sass'
})
export class RequestAddComponent implements OnInit {
  projectNr: string = '';
  companyId: number = 0;
  projectId: string = '';

  positions: Positions[] = [];
  selectedPositions: Positions[] = [];
  parentsName: string = ''
  choose: ChoosenPositions[] = [];
  loading: boolean = true;
  devMode: boolean;


  constructor(
    private route: ActivatedRoute,
    private projss: ProjectsStoreService
  ) {
    ClarityIcons.addIcons(twoWayArrowsIcon, plusIcon, nodeIcon, bundleIcon);
    this.devMode = env.stages.dev;
  }

  ngOnInit() {
    const params = this.route.snapshot.paramMap;
    this.projectNr = params.get('prid') ?? '';
    this.companyId = parseInt(this.splitProjectNumber(this.projectNr, 0));
    this.projectId = this.splitProjectNumber(this.projectNr, 1);
    this.loadProjectsPositions(this.projectNr);
  }

  splitProjectNumber(projectId: string, substring: number) {
    var splits = projectId.split('.');
    return splits[substring];
  }

  addChoosen(component: Positions[]){
    this.choose = [];
    let getParent: string = '';

    component.forEach(value => {
      const position = value.position ?? 0;
      const part = value.positions_part ?? 0;
      const hasChild = value.has_child ?? false;
      const numberOfSubparts = value.number_of_subparts ?? 0;
      const technicalDrawing = value.technical_drawing ?? '';
      const material = value.material ?? '';

      getParent = this.defineParent(position, part, hasChild) ?? '';

      this.choose.push({
        parents_name: getParent,
        parent_component: hasChild.toString(),
        position: position.toString(),
        part: part.toString(),
        anzahl: numberOfSubparts,
        technical_drawing: technicalDrawing,
        material: material})
    })
  }

  defineParent(position: number, part: number, isParent: boolean): string {
    if ((!isParent) && (part > 0)) {
      const myResult = this.positions.find(
        c => c.position === position && c.positions_part === 0
      )
      if (myResult) {
        return myResult.technical_drawing ?? '';
      }
    } else {
      return '';
    }
    return '';
  }

  showParent(part: number | undefined, technicalDrawing: string) {
    if (part == 0 ) this.parentsName = technicalDrawing;
    return this.parentsName;
  }

  loadProjectsPositions(projectId: string) {
    this.projss.getPositionsParts(projectId, "0", "0").pipe(
      map(res => (res?.object ?? []).filter(p => p.active === true))
    ).subscribe({
      next: (activePositions) => {
        this.positions = activePositions;
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {
        return;
      }
    });
  }

  get filterByTechnology() {
    return this.positions.filter( x => !x.technology)
  }
}
